import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconPlus = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 28 28" fill="currentColor">
    <path
      d="M3.5 14L24.5 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 3.5L14 24.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
